import type { FullCancellationCostsData } from '../../domain/types'
import type { CancellationCostsAPIResponse } from '../types'

export function fullCancellationCostsMapper(
  data: CancellationCostsAPIResponse,
): FullCancellationCostsData {
  return {
    isFreeCancellationAllowed: data.isFreeCancellationAllowed === true,
    isCancellationWithCostsAllowed: data.isCancellationWithCostsAllowed === true,
    freeCancellationLimitDate: data.freeCancellationLimitDate ?? '',
    amountPaid: data.amountPaid ?? null,
    amountToPay: data.amountToPay ?? null,
    cancellationCost: data.cancellationCost ?? null,
  }
}
